define('models/zendesk/FieldCollection',['underscore','ObjectCollection','LocalStorage','app','models/zendesk/FieldModel'],
    function (_,ObjectCollection,LocalStorage,app,FieldModel) {
    //
    // Collection Zendesk Field
    //
    var FieldCollection =   ObjectCollection.extend({

        name:'ZendeskFieldCollection',
        route:'apiZendeskField',
        bundleId:'fields',
        idAttribute:'id',
        model:FieldModel,

        getFieldsInForm: function (ids) {

            var collection = this;
            return new _(ids).map(function(id)
                {
                    return collection.get(id);
                });

        },

        filterById: function(idArray) {
            return this.model.reset(_.map(idArray, function(id) { return this.get(id); }, this.model));
        }
    }).extend(LocalStorage);
return FieldCollection;
});
